const COSMIC_PAGES = ["01", "07", "13", "19", "25", "31", "37", "43"].map((n) => `/books/pages/cosmic-${n}.webp`);
const BOLLYDOLL_PAGES = ["01", "07", "14", "20", "27", "33", "40", "46"].map((n) => `/books/pages/bollydoll-${n}.webp`);

export const BOOKS = [
  {
    title: "Cosmic and Eternal Love",
    cover: "/books/cosmic-love.jpg",
    note: "the storybook",
    blurb:
      "A traditional Indian love story told through Amrita's hand-drawn art — the book at the heart of the Cosmic and Eternal Love world.",
    links: [{ label: "Barnes & Noble", href: "https://www.barnesandnoble.com/s/cosmic%20and%20eternal%20love%20amrita%20sen" }],
    pages: COSMIC_PAGES,
  },
  {
    title: "Cosmic and Eternal Love — Coloring Book",
    cover: "/books/cosmic-coloring.jpg",
    note: "colour it yourself",
    blurb:
      "No ordinary colouring book: the love story woven into incredibly detailed black-and-white drawings, with a musical CD of Amrita's own songs composed to accompany the story.",
    links: [{ label: "Barnes & Noble", href: "https://www.barnesandnoble.com/s/cosmic%20and%20eternal%20love%20amrita%20sen" }],
    pages: COSMIC_PAGES,
  },
  {
    title: "Cosmic and Eternal Love — Wall Art Edition",
    cover: "/books/cosmic-wallart.jpg",
    note: "the art edition",
    blurb:
      "The world of Cosmic and Eternal Love released from the page — an edition made for walls rather than shelves.",
    links: [{ label: "Barnes & Noble", href: "https://www.barnesandnoble.com/s/cosmic%20and%20eternal%20love%20amrita%20sen" }],
  },
  {
    title: "Awakened — The Story of the Buddha's Wife",
    cover: "/books/awakened.jpg",
    note: "the untold story",
    blurb:
      "The story history left behind: the Buddha's wife, awakened in her own right — retold and illustrated by Amrita.",
  },
  {
    title: "BollyDoll",
    cover: "/books/bollydoll.jpg",
    note: "the world of Rani & Sheena",
    blurb:
      "The music-filled story of two princess sisters, Rani and Sheena, in BollyWorld — first launched through Art Basel in 2011.",
    links: [{ label: "bollydoll.com", href: "https://bollydoll.com/" }],
    pages: BOLLYDOLL_PAGES,
  },
];
